import styled, { css, keyframes } from "styled-components";

const pulso = keyframes`
  0%   { opacity: 1; }
  50%  { opacity: .45; }
  100% { opacity: 1; }
`;

// A cor #E6E9E7 sobre branco e decorativa (aria-hidden); o aviso real vai no texto .so-leitor.
export const Bloco = styled.div`
  width: 100%;
  min-width: 0;
  margin: 12px 0;

  .so-leitor{
    position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0;
    overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0;
  }

  .pulsa{
    background: #E6E9E7;
    border-radius: 6px;
    animation: ${pulso} 1.4s ease-in-out infinite;
  }
  @media (prefers-reduced-motion: reduce){
    .pulsa{ animation: none; }
  }

  &.v-cartao{
    display: flex; flex-wrap: wrap; gap: 24px;
    .item{ width: 266px; max-width: 100%; padding: 0 0 20px; border-radius: 10px; background: #FAFBFA; box-shadow: 0 1px 4px rgba(0,0,0,.08); overflow: hidden; }
    .capa{ width: 100%; height: 140px; border-radius: 0; }
    .titulo{ width: 60%; height: 18px; margin: 18px 16px 12px; }
    .l1{ width: calc(100% - 32px); height: 12px; margin: 0 16px 8px; }
    .l2{ width: 55%; height: 12px; margin: 0 16px; }
  }

  &.v-linha{
    display: flex; flex-direction: column; gap: 14px;
    .item{ display: flex; align-items: center; gap: 14px; padding: 8px 0; }
    .avatar{ flex: none; width: 40px; height: 40px; border-radius: 50%; }
    .textos{ flex: 1; min-width: 0; }
    .l1{ width: 55%; height: 14px; margin-bottom: 8px; }
    .l2{ width: 80%; height: 12px; }
  }

  /* barras: ranking horizontal (rotulo + barra de comprimento variado) */
  &.v-barras{
    display: flex; flex-direction: column; gap: 14px;
    .item{ display: flex; align-items: center; gap: 12px; }
    .rotulo{ flex: none; width: 120px; height: 14px; }
    .barra{ height: 18px; border-radius: 4px; }
  }

  /* grafico: titulo + area do grafico com colunas de alturas variadas */
  &.v-grafico{
    .item{ padding: 18px 20px 20px; border-radius: 10px; background: #FAFBFA; box-shadow: 0 1px 4px rgba(0,0,0,.08); margin-bottom: 20px; }
    .titulo{ width: 38%; height: 18px; margin-bottom: 18px; }
    .area{ display: flex; align-items: flex-end; gap: 10px; height: 220px; padding-top: 8px; border-bottom: 2px solid #E6E9E7; }
    .coluna{ flex: 1; border-radius: 4px 4px 0 0; }
  }

  &.v-texto{
    .item{ display: flex; flex-direction: column; gap: 10px; }
    .l1{ width: 100%; height: 14px; }
    .l2{ width: 62%; height: 14px; }
  }
`;

// Lista que ja tem dados e esta recarregando (filtro, pagina): mantem o conteudo antigo
// com leve opacidade em vez de piscar vazia ou cobrir a tela.
export const Recarregando = styled.div`
  transition: opacity .15s ease;
  ${(p) => p.$ativo && css`opacity: .55; pointer-events: none;`}
`;
